import React from 'react'

import {isEmpty} from 'es-toolkit/compat'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import Link from '../link'
import Tooltip from '../tooltip'
import TooltipHandler from '../tooltip-handler'

type Props = Overwrite<
  CommonProps<'ul'>,
  {
    children: string[]
    maxLength?: number
    moreLabel: string
  }
>

const sliceList = (list: React.ReactNode[], maxLength: number) => {
  const truncatedList = list.slice(0, maxLength)
  const moreList = list.slice(maxLength)

  return [truncatedList, moreList]
}

const MaterialListEnumeration = ({
  className,
  children,
  maxLength = 5,
  moreLabel,
  ...props
}: Props) => {
  const [list, more] = sliceList(children, maxLength)

  return (
    <ul {...props} className={cn('MaterialListEnumeration', {}, className)}>
      {list.map((child, index) => (
        <li key={index} className="MaterialListEnumeration__item">
          {child}
        </li>
      ))}
      {!isEmpty(more) ? (
        <li className="MaterialListEnumeration__item">
          <TooltipHandler
            openOnClick
            tooltip={
              <Tooltip>
                {more.map((child, index) => (
                  <div key={index}>{child}</div>
                ))}
              </Tooltip>
            }
          >
            <Link>
              + {more.length} {moreLabel}
            </Link>
          </TooltipHandler>
        </li>
      ) : null}
    </ul>
  )
}

export default MaterialListEnumeration
